import { Bell } from "lucide-react";
import { useLocation } from "react-router-dom";

const CRUMB_MAP = {
  "/": ["Overview", "Dashboard"],
  "/knowledge": ["Knowledge", "Graph"],
  "/companies": ["Knowledge", "Companies"],
  "/sources": ["Knowledge", "Sources"],
  "/articles": ["Knowledge", "Editorial"],
  "/editorial": ["Knowledge", "Editorial"],
  "/daily-briefs": ["Intelligence", "Daily Briefs"],
  "/memory": ["Intelligence", "Memory"],
  "/agents": ["Orchestration", "Agents"],
  "/workflows": ["Orchestration", "Workflows"],
  "/logs": ["Orchestration", "Logs"],
  "/settings": ["System", "Settings"],
};

export default function Topbar({ user, onLogout }) {
  const location = useLocation();
  const crumbs = CRUMB_MAP[location.pathname] || ["Workspace", "—"];

  return (
    <div className="h-[52px] flex items-center gap-4 px-6 border-b border-hm-border bg-hm-bg">
      <div className="flex items-center gap-2 mono text-[11px] uppercase tracking-[0.18em]">
        <span className="text-hm-fg-subtle">Beyond Activ</span>
        <span className="text-hm-fg-subtle">/</span>
        <span className="text-hm-fg-muted">{crumbs[0]}</span>
        <span className="text-hm-fg-subtle">/</span>
        <span className="text-hm-fg">{crumbs[1]}</span>
      </div>

      <div className="flex-1" />

      <button
        className="relative h-8 w-8 flex items-center justify-center rounded-md text-hm-fg-muted hover:text-hm-fg hover:bg-hm-bg-1 transition-colors"
        title="Notifications (empty)"
      >
        <Bell className="h-4 w-4" />
      </button>

      {user && (
        <div className="flex items-center gap-2 pl-3 border-l border-hm-border">
          <div className="h-7 w-7 rounded-full bg-hm-bg-2 border border-hm-border-strong flex items-center justify-center text-[11px] text-hm-fg-muted">
            {user.name?.[0]?.toUpperCase() || user.email?.[0]?.toUpperCase() || "?"}
          </div>
          <div className="hidden md:flex flex-col leading-none">
            <span className="text-xs text-hm-fg">{user.name || "—"}</span>
            <span className="mono text-[10px] text-hm-fg-subtle" data-testid="topbar-user-email">
              {user.email}
            </span>
          </div>
          {onLogout && (
            <button
              data-testid="topbar-logout"
              onClick={onLogout}
              className="ml-2 mono text-[10px] uppercase tracking-widest text-hm-fg-subtle hover:text-hm-fg"
            >
              logout
            </button>
          )}
        </div>
      )}
    </div>
  );
}
